<div class="card">
  <div class="card-header">
    <div class="row align-items-center flex-nowrap">
      <div class="col">
        <div class="row g-2 flex-nowrap">
          <div class="col-auto">
            <div class="card-icon">
              <i class="bx bxs-coffee"></i>
            </div>
          </div>
          <div class="col">
            <h4 class="m-0">Dining</h4>
            <p class="m-0">Today's Meals</p>
          </div>
        </div>
      </div>
      <div class="col text-end lh-1">
        <a [routerLink]="['dining']" class="text-icon float-end">
          See the menu
          <i class="bx bx-chevron-right"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="card-body">
    <ng-container *ngIf="(locations$ | async)?.length; else empty">
      <accordion [isAnimated]="true" [closeOthers]="true" class="accordion-default">
        <accordion-group
          class="mb-3"
          *ngFor="let item of locations$ | async; let i = index"
          [isOpen]="i === 0"
          #group
        >
          <div accordion-heading>
            <div class="row align-items-">
              <div class="col">{{ item.name | titlecase }}</div>
              <div class="col-auto">
                <i
                  [class.bx-chevron-down]="!group.isOpen"
                  [class.bx-chevron-up]="group.isOpen"
                  class="bx float-end"
                ></i>
              </div>
            </div>
          </div>

          <div class="card card-light" *ngIf="item.breakfast">
            <div class="card-body">
              <h6 class="fw-bolder">Breakfast</h6>
              <p class="m-0">
                <i class="bx bxs-time text-primary"></i>
                {{ item.breakfast.start | date: 'hh:mm a' }}
                - {{ item.breakfast.end | date: 'hh:mm a' }}
              </p>
            </div>
          </div>

          <div class="card card-light" *ngIf="item.lunch">
            <div class="card-body">
              <h6 class="fw-bolder">Lunch</h6>
              <p class="m-0">
                <i class="bx bxs-time text-primary"></i>
                {{ item.lunch.start | date: 'hh:mm a' }}
                - {{ item.lunch.end | date: 'hh:mm a' }}
              </p>
            </div>
          </div>

          <div class="card card-light m-0" *ngIf="item.dinner">
            <div class="card-body">
              <h6 class="fw-bolder">Dinner</h6>
              <p class="m-0">
                <i class="bx bxs-time text-primary"></i>
                {{ item.dinner.start | date: 'hh:mm a' }}
                - {{ item.dinner.end | date: 'hh:mm a' }}
              </p>
            </div>
          </div>
        </accordion-group>
      </accordion>
    </ng-container>
  </div>
</div>

<ng-template #empty>
  <div class="row">
    <div class="col-12">
      <div role="alert" class="alert alert-info d-flex">
        <i class="bx bxs-info-circle me-2 mt-1"></i>
        <div>
          <h6 class="m-0 fw-bolder">No dining data to display.</h6>
          <p class="m-0">Contact your community for dining information.</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
